
import React, { useState, useEffect,useLayoutEffect } from 'react'
import Head from 'next/head'
import Main from '../../components/ReportProfile/Main';




export async function getServerSideProps({ req, res, resolvedUrl }) {
    const UA = req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ))

    let slug = resolvedUrl;
    let full_slug = process.env.APP_URL + resolvedUrl;
    if (slug.includes('/_next/')) {
        // checking if it making request json file then skip to fetch Meta Data
        return {
            props: {
                metaDetails: {
                    meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
                    meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
                    meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
                },
                slug: full_slug
            }
        };
    } else {
        // Remove the trailing slash, if any
        let cleanedSlug = slug.replace(/\/$/, '');
        cleanedSlug = cleanedSlug.replace(/\/report-store\//, '');
        try {
            // const response = await axios.get(process.env.API_URL + '/report/' + cleanedSlug);
            const apiUrl = process.env.API_URL + '/report/' + cleanedSlug;

            const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            });

            const metaDetails = await response.json();
            // Now you can use the metaDetails object as needed.
            if (metaDetails == undefined || metaDetails == '' || metaDetails == null || metaDetails?.code === 404) {
                return {
                    redirect: {
                        permanent: false,
                        destination: "/404"
                    }
                }
            } else {
                return {
                    props: {
                        metaDetails: {
                            meta_title: (metaDetails.report_data.meta.meta_title) ? metaDetails.report_data.meta.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
                            meta_description: (metaDetails.report_data.meta.meta_description) ? metaDetails.report_data.meta.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
                            meta_keywords: (metaDetails.report_data.meta.meta_keywords) ? metaDetails.report_data.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
                            schema: (metaDetails.report_data.meta.meta_schema) ? metaDetails.report_data.meta.meta_schema : null,
                        },
                        slug: full_slug,
                        deviceType: isMobile ? 'mobile' : 'desktop',
                        reportData: metaDetails
                    },
                };

            }
            // } else {
            // console.error('Failed to fetch data from API:', response.statusText);
            // return {
            //     redirect: {
            //         permanent: false,
            //         destination: "/404"
            //     }
            // };
            // }

        } catch (error) {
            return {
                redirect: {
                    permanent: false,
                    destination: "/404"
                }
            };
        }
    }
}

const PostPage = ({ reportData, metaDetails, slug }) => {
    const [showChild, setShowChild] = useState(false);

    useEffect(()=>{
        setShowChild(true);
    },[])
    
    return (
        <>
            <Head>
                <title>{(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "}</title>
                <meta name="description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
                <meta name="keywords" content={(metaDetails != undefined) ? metaDetails.meta_keywords : (metaData) ? metaData?.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."} />
                <meta property="og:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
                <meta property="og:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
                <meta name="twitter:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
                <meta name="twitter:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
                <meta property="og:url" content={(slug) ? slug : metaSlug} />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: metaDetails?.schema != null ?
                            metaDetails?.schema.replace(/<script[^>]*>|<\/script>/g, '') : null
                    }}
                />
            </Head>
            {(showChild) && 
            <Main reportData={reportData}/>
            }
            
           
        </>
    );
};


export default PostPage;




